"use client";

import { Instagram, Linkedin, Mail, Video } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
function FooterMenuLinks() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="flex flex-col gap-[14px]">
        {[0, 1, 2, 3].map(i => <li key={i} data-index={i} className="h-4 w-32 bg-border animate-pulse rounded-sm" />)}
      </ul>;
  }
  return <ul className="flex flex-col gap-[14px]">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link className="group inline-flex items-center text-[1rem] font-normal text-foreground/90 hover:text-primary transition-colors duration-240" to={item.href || "#"}>
            <span className="relative">
              {item.label}
              <span className="absolute left-0 -bottom-1 h-px w-0 bg-primary transition-all duration-240 ease-out group-hover:w-full" />
            </span>
          </Link>
        </li>)}
    </ul>;
}
const offices = [{
  label: "Coral Gables",
  to: "https://inspired-chamois-1.cynergiasites.com/contact-contacto/"
}, {
  label: "Brickell",
  to: "https://inspired-chamois-1.cynergiasites.com/contact-contacto/"
}];
const socials = [{
  label: "Instagram",
  icon: Instagram,
  to: "https://www.instagram.com/valeroelitedetailing"
}, {
  label: "Email",
  icon: Mail,
  to: "mailto:valeroelitedetailing@gmail.com"
}];
const legal = [{
  label: "Privacy",
  to: "#"
}, {
  label: "Terms",
  to: "#"
}, {
  label: "Policy",
  to: "#"
}];
export default function Footer() {
  return <section data-section-id="28771" id="valero-elite-footer" data-nav="dark" className="text-foreground bg-background">
      <div className="mx-auto max-w-[1440px]" style={{
      paddingLeft: "clamp(24px, 5vw, 88px)",
      paddingRight: "clamp(24px, 5vw, 88px)",
      paddingTop: "clamp(80px, 12vh, 140px)",
      paddingBottom: "40px"
    }}>
        <div className="flex text-center justify-center pb-12" style={{
        minHeight: "clamp(50px,3vw,60px)"
      }}>
          <Link to="https://inspired-chamois-1.cynergiasites.com/">
            <WvcLogo className="h-[clamp(50px,3vw,60px)] w-auto !bg-[rgba(0,0,0,0.47)] !text-[rgba(241,236,228,0)] [&_svg]:h-[clamp(50px,3vw,60px)] [&_svg]:w-auto [&_svg]:!bg-[rgba(0,0,0,0.47)] [&_svg]:!text-[rgba(241,236,228,0)]" />
          </Link>
        </div>
        <div className="h-px w-full bg-border" />

        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-x-6 md:gap-y-0 pt-16 md:pt-20">
          <div className="md:col-span-4">
            <p className="mt-6 max-w-[320px] font-sans text-muted-foreground" style={{
            fontSize: "1rem",
            lineHeight: 1.7
          }}>
              Premium mobile car detailing. We bring luxury care to your home or office in Miami.
            </p>
            <div className="mt-10 flex items-center gap-5">
              {socials.map((social, i) => {
              const Icon = social.icon;
              return <Link key={social.label} data-index={i} to={social.to} aria-label={social.label} className="text-muted-foreground hover:text-primary transition-colors duration-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 focus-visible:ring-offset-background rounded-sm">
                    <Icon strokeWidth={1} className="h-6 w-6" />
                  </Link>;
            })}
            </div>
          </div>

          <div className="md:col-span-2">
            <div className="font-sans uppercase text-muted-foreground" style={{
            fontSize: "0.75rem",
            fontWeight: 500,
            letterSpacing: "0.22em",
            lineHeight: 1.4
          }}>
              EXPLORE
            </div>
            <div className="mt-5">
              <MenuProvider menu_id="3">
                <FooterMenuLinks />
              </MenuProvider>
            </div>
          </div>

          <div className="md:col-span-2">
            <div className="font-sans uppercase text-muted-foreground" style={{
            fontSize: "0.75rem",
            fontWeight: 500,
            letterSpacing: "0.22em",
            lineHeight: 1.4
          }}>
              AREAS
            </div>
            <ul className="mt-5 flex flex-col gap-[14px]">
              {offices.map((office, i) => <li key={office.label} data-index={i}>
                  <Link to={office.to} className="group inline-flex items-center text-[1rem] font-normal text-foreground/90 hover:text-primary transition-colors duration-240">
                    <span className="relative">
                      {office.label}
                      <span className="absolute left-0 -bottom-1 h-px w-0 bg-primary transition-all duration-240 ease-out group-hover:w-full" />
                    </span>
                  </Link>
                </li>)}
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="font-sans uppercase text-muted-foreground" style={{
            fontSize: "0.75rem",
            fontWeight: 500,
            letterSpacing: "0.22em",
            lineHeight: 1.4
          }}>
              BOOKING
            </div>
            <div className="mt-5">
              
            </div>
            <div className="mt-2 font-sans text-muted-foreground" style={{
            fontSize: "0.875rem",
            lineHeight: 1.5,
            letterSpacing: "0.02em"
          }}>
              By appointment
            </div>
            <div className="mt-8">
              <Button asChild className="rounded-lg border border-primary/50 bg-transparent text-foreground hover:border-primary hover:text-primary transition-all duration-300 h-auto" style={{
              padding: "14px 26px",
              fontSize: "0.9375rem",
              fontWeight: 500,
              letterSpacing: "0.04em"
            }}>
                <Link to="https://wa.me/17867784394" newTab>Book via WhatsApp</Link>
              </Button>
            </div>
          </div>
        </div>

        <div className="mt-14">
          <div className="h-px w-full bg-border" />
          <div className="pt-6 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
            <div className="font-sans text-muted-foreground" style={{
            fontSize: "0.875rem",
            lineHeight: 1.5,
            letterSpacing: "0.02em"
          }}>
              {"© Valero Elite Detailing."}
            </div>
            <div className="flex flex-wrap items-center gap-6">
              {legal.map((item, i) => <Link key={item.label} data-index={i} to={item.to} className="group inline-flex items-center font-sans text-foreground/90 hover:text-primary transition-colors duration-240" style={{
              fontSize: "0.875rem",
              letterSpacing: "0.02em"
            }}>
                  <span className="relative">
                    {item.label}
                    <span className="absolute left-0 -bottom-1 h-px w-0 bg-primary transition-all duration-240 ease-out group-hover:w-full" />
                  </span>
                </Link>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}